import { useTranslation } from 'react-i18next';
import type { CreateApiTokenResponseDto } from '../model';
import { CopyField } from '@/shared/components';

type Props = {
  apiToken: CreateApiTokenResponseDto;
};

const CreateApiTokenResultDetails = ({ apiToken }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-[2.4rem] px-[2.4rem] py-[1.6rem] bg-muted rounded-[1.6rem] mb-[3.2rem] w-full">
      <div className="flex flex-col gap-[0.2rem]">
        <label className="p4 text-muted-foreground">
          {t('webApiTokens.fieldLabels.id')}:
        </label>
        <CopyField value={apiToken.webapiTokenid} variant="compact" />
      </div>

      <div className="flex flex-col gap-[0.2rem]">
        <label className="p4 text-muted-foreground">
          {t('webApiTokens.fieldLabels.key')}:
        </label>
        <CopyField value={apiToken.key} variant="compact" />
      </div>

      <div className="flex flex-col gap-[0.2rem]">
        <label className="p4 text-muted-foreground">
          {t('webApiTokens.fieldLabels.secret')}:
        </label>
        <CopyField value={apiToken.secret} variant="compact" />
      </div>

      <div className="flex gap-[1.6rem] items-center">
        <div className="flex flex-col gap-[0.2rem] flex-1">
          <label className="p4 text-muted-foreground">
            {t('webApiTokens.fieldLabels.authenticationType')}:
          </label>

          <span className="headline4 text-primary break-all">
            {apiToken.authenticationType}
          </span>
        </div>

        <div className="flex flex-col gap-[0.2rem] flex-1">
          <label className="p4 text-muted-foreground">
            {t('webApiTokens.fieldLabels.accessRights')}:
          </label>

          <span className="headline4 text-primary break-all">
            {apiToken.access}
          </span>
        </div>
      </div>
    </div>
  );
};

export { CreateApiTokenResultDetails };
